/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Spinner from './spinner';

export default ( props ) => {
	if ( props.error ) {
		return <div>Error! <button onClick={ props.retry }>Retry</button></div>;
	} else if ( props.pastDelay ) {
		return <Spinner />;
	}

	return null;
};



// WEBPACK FOOTER //
// ./src/components/loading/index.js